import { genericGetCallRequest } from 'utils/request';
import FileSaver from 'file-saver';
import { uploadToBucketCall } from 'redux-core/images/services';
import { getTemplateFileUrlCall, getTracksImportUploadAccessCall } from './services';

const allowedImageTypes = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

const getContentType = (fileName, kind) => {
  if (Object.values(allowedImageTypes).includes(kind) || kind === 'IMAGE') {
    const ext = fileName.split('.').pop();
    const type = allowedImageTypes[ext] || `image/${ext}`;
    return type;
  }

  return 'binary/octet-stream';
};

export const getTemplateFile = () => async () => {
  const url = await getTemplateFileUrlCall();
  const blob = await genericGetCallRequest({
    url,
    responseType: 'blob',
  });
  FileSaver.saveAs(blob, 'tracks_import_template.xlsx');
  return true;
};

export const uploadTracksImportFileCall = async (
  file,
  { kind },
) => {
  const fileName = file.name || file.fileName;
  const contentType = getContentType(fileName, kind);

  const { key, uploadUrl } = await getTracksImportUploadAccessCall({
    kind,
    contentType,
  });

  await uploadToBucketCall(uploadUrl, { file, contentType });
  return key;
};
